import { Component, computed, effect, HostListener, Inject, signal, ViewChild } from '@angular/core';
import { KopModulesService } from '../../modules/kop-modules.service';
import { KanaalService } from '../../kanaal/kanaal.service';
import { JSBridgeService } from '../jsbridge.service';
import { ServerAPI } from '../../serverapi';
import { KopConfigService } from '../kop-config.service';
import { AutosaveService } from '../autosave.service';
import { MetaOverviewComponent } from '../../modules/meta-overview/meta-overview.component';
import { KopHistoryComponent } from '../kop-history/kop-history.component';
import { TranslateService } from '../../i18n/translate.service';
import { XMLCompareComponent } from '../../debug/xmlcompare/xmlcompare.component';


@Component({
  selector: 'app-bar',
  templateUrl: './app-bar.component.html',
  styles: `
  .appbar {
    background-color: var(--skov-primary);
  }
  `,
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'AppBarComponent'
    }
  ]


})
export class AppBarComponent {

  constructor(public kopModulesService: KopModulesService, public jsBridgeService: JSBridgeService, public kanaalService: KanaalService,
    @Inject('ServerApi') public electronAPI: ServerAPI, private kopConfigService: KopConfigService, public autoSaveService: AutosaveService,
    public translateService: TranslateService, @Inject('i18n-label') private i18nLabel: any
  ) {
    this.updateWriteAccess();
    effect(() => {

      let hl = this.electronAPI.hasLock();
      this.updateWriteAccess();
    });

    effect(() => {
      this.translateService.translateSignal();
      this.translateMenu(this.configOptions);
      this.translateMenu(this.fileOptions);
    });

  }

  private async translateMenu(menu: { text: string, textKey: string }[]) {
    for (let i = 0; i < menu.length; i++) {
      menu[i].text = await this.translateService.getTranslation(this.i18nLabel, menu[i].textKey, menu[i].textKey);
    }
  }

  @ViewChild(MetaOverviewComponent, { static: true }) metaOverview: MetaOverviewComponent | undefined = undefined;
  @ViewChild(KopHistoryComponent, { static: true }) kopHistory: KopHistoryComponent | undefined = undefined;

  private async updateWriteAccess() {
    let canWrite = await this.electronAPI.canWriteKlant(this.jsBridgeService.getKlantNo())
    this.showSaveButon = canWrite;
    if (!canWrite) {
      this.fileOptions[0].disabled = true;
      this.fileOptions[1].disabled = true;
    } else {
      this.fileOptions[0].disabled = false;
      this.fileOptions[1].disabled = false;
    }
  }


  public editVrijAlarmen = signal(false);
  public editUren = signal(false);
  public editGlobalConfig = signal(false);
  public editGlobalConfigExtra = signal(false);
  public editModbus = signal(false);
  public generateList = signal(false);
  public unlock = signal(false);
  public showSaveButon = true;

  public configOptions = [{
    text: "Configuratie",
    textKey: "Configuratie",
    click: () => {
      this.editGlobalConfig.set(true);
    }
  }, {
    text: "Extra Configuratie",
    textKey: "Extra Configuratie",
    click: () => {
      this.editGlobalConfigExtra.set(true);
    }
  }, {
    text: "Vrije Alarm Teksten",
    textKey: "Vrije Alarm Teksten",
    click: () => {
      this.editVrijAlarmen.set(true);
    }
  },
  {
    text: "Urentellers & Speciale Teksten",
    textKey: "Urentellers & Speciale Teksten",
    click: () => {
      this.editUren.set(true);
    }
  },
  {
    text: "Modbus Netwerken",
    textKey: "Modbus Netwerken",
    click: () => {
      this.editModbus.set(true);
    }
  },
  ];

  public fileOptions = [{
    text: "Opslaan (Ctrl+s)",
    textKey: "Opslaan (Ctrl+s)",
    disabled: false,
    click: () => {
      this.kopModulesService.save("");
    }
  },
  {
    text: "Opslaan met Overzicht",
    textKey: "Opslaan met Overzicht",
    disabled: false,
    click: () => {
      this.kopModulesService.saveWithComments();
    }
  },
  {
    text: "Kop geschiedenis",
    textKey: "Kop geschiedenis",
    click: () => {
      this.kopHistory?.open();
    }

  },
  // {
  //   text: "XML Vergelijken",
  //   textKey: "XML Vergelijken",
  //   click: () => {
  //     this.xmlCompare?.open();
  //   }
  // },
  {
    text: "Lijsten genereren",
    textKey: "Lijsten genereren",
    click: () => {
      this.generateList.set(true)
    }
  },
  {
    text: "Unlock & Download",
    textKey: "Unlock & Download",
    click: () => {
      this.unlock.set(true)
    }
  }

  ];

  public extraOptions = [{
    text: "Modules",
    click: () => {
      this.metaOverview?.open();
    }
  }, {
    text: "Sercom Dev (On)",
    click: () => {
      this.onDev();
      this.extraOptions[1].text = this.jsBridgeService.isDev() ? "Sercom Dev (Off)" : "Sercom Dev (On)"
    },
  }, {
    text: "Save Translations",
    click: () => {
      this.translateService.saveStaticRepo();
    }
  }
  ];

  public showKanaalOverview = signal(false);

  public assign = computed(() => {
    this.kopConfigService.afdelings();
    this.kopConfigService.selectedAfd();
    let kfg = this.jsBridgeService.getBridgeSync().getConfig();
    let assignement = this.kanaalService.getKonfigKanalen(kfg);
    return assignement;
  });


  public async compile() {
    this.jsBridgeService.getBridgeSync().save();

    await this.jsBridgeService.compileBin();
    await this.jsBridgeService.compilePCIBBin();
  }

  @HostListener('document:keydown.control.s', ['$event'])
  shortcut(event: Event) {
    event.preventDefault();
    this.kopModulesService.save("");

  }

  public onDev() {
    this.jsBridgeService.isDev.set(!this.jsBridgeService.isDev());
  }

}
